import React, { forwardRef, useEffect, useRef } from "react";
import Quill from 'quill';
import "quill/dist/quill.snow.css";
import { Delta } from 'quill/core';

import "./quill.scss"

interface QuillDisplayerProps {
    defaultValue: Delta,
}

export type Ref = HTMLDivElement;

const QuillDisplayer = forwardRef<Ref, QuillDisplayerProps>(
    ({ defaultValue }, ref) => {
        const containerRef = useRef(null);
        const defaultValueRef = useRef(defaultValue);

        useEffect(() => {
            if (ref && typeof ref === "object" && "current" in ref && ref.current) {
                (ref.current as unknown as Quill).setContents(defaultValue);
            }
        }, [ref, defaultValue]);

        useEffect(() => {
            const container = containerRef.current;
            if (!container) return;
            const editorContainer = container.appendChild(
                container.ownerDocument.createElement("div"),
            );
            const quill = new Quill(editorContainer, {
                modules: {
                    toolbar: false,
                },
            });
            if (ref && typeof ref === "object" && "current" in ref) {
                (ref as unknown as React.MutableRefObject<Quill | null>).current = quill;
            }

            quill.enable(false);

            if (defaultValueRef.current) {
                quill.setContents(defaultValueRef.current);
            }

            return () => {
                if (ref && typeof ref === "object" && "current" in ref) {
                    (ref as unknown as React.MutableRefObject<Quill | null>).current = null;
                }
                container.innerHTML = "";
            };
        }, [ref]);

        return <div className="quillDisplayEditor" ref={containerRef}></div>;
    },
);


export default QuillDisplayer;